package org.vreo.devicehub.features.device.data.mappers

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.domain.device.device.ProductType
import org.vreo.devicehub.features.core.data.device.dto.AnprDetailsResponseDto
import org.vreo.devicehub.features.core.data.device.dto.AnprDeviceRequestDto


/**
 * Map AnprDetailsResponseDto to ANPR device
 *
 * @return ANPR device
 */
@OptIn(ExperimentalTime::class)
fun AnprDetailsResponseDto.toAnprDevice(): AnprDevice {
    val lastActive = if (this.lastActivityTime != null) {
        val instant = Instant.fromEpochMilliseconds(this.lastActivityTime)
        instant.toLocalDateTime(TimeZone.currentSystemDefault())
    } else {
        null
    }

    val device = ProductType.getByProductNumber(this.productNumber)
        ?: throw IllegalArgumentException("Failed to parse product number: ${this.productNumber}")

    return AnprDevice(
        deviceId = this.id,
        device = device,
        serialNumber = this.serialNumber,
        softwareVersion = this.softwareVersion ?: "",
        ocrVersion = this.ocrVersion ?: "",
        localIpAddress = this.localIpAddress ?: "",
        macAddress = this.macAddress ?: "",
        active = this.connectionStatus,
        lastActivityTime = lastActive,
        userTag = this.userTag,
        linkinPassword = linkingKey,
        primaryConnectionKey = this.primaryConnectionKey
    )
}

/**
 * Map AnprDetails to AnprDeviceRequestDto
 */
fun AnprDevice.toAnprDeviceRequestDto(): AnprDeviceRequestDto {
    return AnprDeviceRequestDto(
        productNumber = this.device.productNumber,
        serialNumber = this.serialNumber.toLong(),
        tag = this.userTag
    )
}